// Mirrors the "Submenu Dropdown Toggle" and "Mobile Nav Hide Show" blocks of
// /js/script.js, which run on document ready - before React has rendered the
// header. Called from the Header component after mount. Idempotent: uses
// namespaced jQuery events and skips work that script.js already did.
export function initMobileMenu() {
    const $ = window.jQuery;
    if (!$) return;

    const $dropdowns = $('.main-header .navigation li.dropdown, .mobile-menu li.dropdown');
    $dropdowns.each(function () {
        if (!$(this).children('.dropdown-btn').length) {
            $(this).append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');
        }
    });

    const $menuBox = $('.mobile-menu .menu-box');
    if ($menuBox.length && $.fn.mCustomScrollbar && !$menuBox.hasClass('mCustomScrollbar')) {
        $menuBox.mCustomScrollbar();
    }

    $('.mobile-menu li.dropdown .dropdown-btn')
        .off('click.reactMenu')
        .on('click.reactMenu', function () {
            $(this).toggleClass('open');
            $(this).prev('ul').slideToggle(500);
        });

    $('.mobile-nav-toggler')
        .off('click.reactMenu')
        .on('click.reactMenu', function () {
            $('body').addClass('mobile-menu-visible');
        });

    $('.mobile-menu .menu-backdrop, .mobile-menu .close-btn, .mobile-menu .close-mobile-menu')
        .off('click.reactMenu')
        .on('click.reactMenu', function () {
            $('body').removeClass('mobile-menu-visible');
        });
}
